export const DIRECTION = { Up: "up", Down: "down" } as const;
export type Direction = typeof DIRECTION[keyof typeof DIRECTION];
